import { useAuth, usePublic } from "contexts";
import { storyConverter } from "db/converters";
import { getDocument } from "db/queries";
import { useParams } from "next/navigation";
import { useState, useEffect } from "react";
import { COLLECTION_NAME } from "services/stories";

/**
 * Hook personalizado para obtener un libro local basado en el ID de la URL.
 * Este hook busca el libro en la biblioteca local o en la colección de historias cargadas.
 * @param {Object} params - Parámetros de la URL, se espera que contenga `bid` (ID del libro).
 * @param {boolean} loading - Indica si las historias están cargando.
 * @param {Array} stories - Lista de historias cargadas desde la biblioteca.
 * @returns {Object|null} - Devuelve el libro local encontrado o null si no se encuentra.
 */
export const useDocument = () => {
  const [book, setBook] = useState(null);
  const { all: collection, loading, ...ctrl } = usePublic();
  const { user } = useAuth();
  const params = useParams();

  useEffect(() => {
    const fetchBook = async () => {
      const storyId = params?.bid;

      if (!loading) {
        const target = collection?.find((story) => story._id == storyId);

        if (target) setBook(target);
        else {
          const result = await getDocument(
            COLLECTION_NAME,
            storyId,
            storyConverter
          );
          setBook(result);
        }
      }
    };

    fetchBook();
  }, [params?.bid, loading, collection, user?.uid]);

  return book;
};
